<template>
    <Widget title="Karma Data" :area="this.$props.area">
        <template v-if="hasData">
            <NameValue type="karma" name="Links" :value="user.link_karma"/>
            <NameValue type="karma" name="Comments" :value="user.comment_karma"/>
            <NameValue type="karma" name="Total" :value="user.link_karma+user.comment_karma"/>
            <apexchart type="pie" :series="[user.link_karma,user.comment_karma]" :options="options"/>
        </template>
    </Widget>
</template>

<script>
    import Widget from "../Widget";
    import {mapGetters} from "vuex";
    import NameValue from "../NameValue";

    export default {
        components: {NameValue, Widget},
        props: {area: String},
        computed: {
            ...mapGetters(['user', 'allPosts', 'comments', 'submissions']),
            hasData() {
                return this.user != null;
            },
            options() {
                return {
                    chart: {
                        foreColor: '#ccc'
                    },
                    colors: ['#fc0', '#0c8'],
                    tooltip: {theme: 'dark'},
                    dataLabels: {enabled: true,},
                    labels: ['Link Karma', 'Comment Karma'],
                    legend: {
                        show: false,
                        floating: true,
                        position: 'top',
                        horizontalAlign: 'right'
                    }
                }
            }
        },
        methods: {
            open() {
            }
        }
    }
</script>

<style scoped>

</style>
